module.exports = __webpack_public_path__ + "static/img/tmptype2.05dba5e0.png";